export default __webpack_public_path__ + "static/media/main.2ae4ddb1.md";